
import { IFlowStartupReferenceDTO } from '@/plugins/typings/DTO/IFlowStartupReferenceDTO';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Inject } from 'vue-property-decorator';
import FlowBoPropertyEditor from './FlowBoPropertyEditor.vue';

@Component({
  name: 'FlowChangeProperties',
  components: {
    FlowBoPropertyEditor,
  },
})
export default class FlowChangeProperties extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  schema: any;

  @Prop({
    type: Object,
    required: true,
  })
  data: any;

  @Prop({
    type: Array,
    required: true,
  })
  value: any;

  @Inject({
    default: null,
  })
  startupTypes: IFlowStartupReferenceDTO[];

  get startupType() {
    if (this.startupTypes) {
      return this.startupTypes.find((s) => s.type === this.data.boType);
    }
    return null;
  }

  handleChangePropertyChange(index, value) {
    this.$emit('input', [...this.value.slice(0, index), value, ...this.value.slice(index + 1)]);
  }
}
